import {
  ChangeDetectorRef,
  
//   Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  WritableSignal,
  inject,
  signal
} from '@angular/core';

import {
  Router,
  RouterLink,
  RouterOutlet
} from '@angular/router';

import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalModule,
  MsalService
} from '@azure/msal-angular';

import {
  AccountInfo,
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  RedirectRequest
} from '@azure/msal-browser';

import {
  filter,
  takeUntil
} from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Subject } from 'rxjs';
import { UserProfileService } from '../service/user-profile.service';
import { UserProfile } from '../model/user-profile';


import { MatListModule } from '@angular/material/list';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { SetUserApexId, SetUserCountry } from '../shared/actions/common-data.action';
import { DriverService } from '../service/driver.service';

import { Component, ViewChild, ElementRef } from '@angular/core';
import { TeamMessageService } from '../service/team-message.service';
import {MatBadgeModule} from '@angular/material/badge';
import { TeamMessageComponent } from '../team-message/team-message.component';
import { TeamMessageDataComponent } from '../team-message-data/team-message-data.component';
import { environment } from '@env/environment';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
        CommonModule,
        // FlexModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MsalModule,
        RouterLink,
        MatListModule,
        MatToolbarModule,
        RouterOutlet,
        // TranslateService,
        TranslateModule,
        MatBadgeModule,
        TeamMessageComponent,
        TeamMessageDataComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent  implements OnInit, OnDestroy  {
  
  @ViewChild('subcontent')
  subContent!: ElementRef;

  

  userProfileMe!:UserProfile;
  store = inject(Store);
  private readonly _destroying$ = new Subject<void>();

  account: WritableSignal<AccountInfo | null> = signal(null);
  isIframe = false;
  evcrLink = environment.link.evcr;
  browserLangToUse = '';
  constructor(
      @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
      private msalBroadcastService: MsalBroadcastService,
      private authService: MsalService,
      private cdr: ChangeDetectorRef,
      private ngZone: NgZone,
      private router: Router,      
      private driverService: DriverService,
      private teamMessageService: TeamMessageService,
      translate: TranslateService,
  ) {     
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    console.log(`home page browser language is ${browserLang}`);
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLangToUse);
    this.browserLangToUse = browserLangToUse;
    console.log(browserLang);

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use(browserLangToUse);

    
  }
  isLoading = false;
  apexId = localStorage.getItem("apexid"); 

  ngOnInit(): void {
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      console.log(`home not override apex id`);
      this.isLoading = true;
      this.pageInitialization();
    } 
    else{
      console.log(`home override apex id`);
      this.isLoading = true;
      this.pageInitializationOverride(overrideObjectString);
    }        
  }
  private pageInitializationOverride(overrideObjectString:string): void{
    let overrideObject = JSON.parse(overrideObjectString);
    this.apexId = overrideObject.apexid;
    this.driverCountry = overrideObject.driverCountry;    
    if(this.driverCountry === 'CN'){
      this.showEconomyKpi = true;            
    }
    if(this.driverCountry === 'TW'){
      this.showHomeButton = false;            
    }
    if(this.apexId !== null){      
      // if(overrideObject.dashboardTeamMessageDetails[0] === null){
      //   this.teamMessageNotReadCunt = null; 
      // }
      // else{
      //   let count = overrideObject.dashboardTeamMessageDetails.filter((item: any) => item.readTime === null).length;
      //   this.teamMessageNotReadCunt = count === 0 ? null : count;
      // }
      this.teamMessageService.getTeamMessageByApexId(this.apexId).subscribe(responseTeamMessageObject => {
        // driver not exist
        if(responseTeamMessageObject.length === 0){
          this.teamMessageNotReadCunt = null;
          overrideObject.dashboardTeamMessageDetails = [];
        }
        else{
          // driver exist, but no team message
          if(responseTeamMessageObject[0].dashboardTeamMessageDetails[0] === null){              
            this.teamMessageNotReadCunt = null;                               
          }
          // driver exist, and has team message
          else{
            let count = responseTeamMessageObject[0].dashboardTeamMessageDetails.filter((item: any) => item.readTime === null).length;                        
            this.teamMessageNotReadCunt = count === 0 ? null : count;            
          }
          overrideObject.dashboardTeamMessageDetails = responseTeamMessageObject[0].dashboardTeamMessageDetails;
        }
        localStorage.setItem('overrideObject', JSON.stringify(overrideObject));
        this.isLoading = false;
      });           
    }    
  }
  private pageInitialization(): void{
    console.log(`enter home ngOnInit`);
    console.log(localStorage.getItem("apexid"));
    console.log(localStorage.getItem("driverCountry"));
    console.log(localStorage.getItem("driverBusinessType"));

    let apexid = localStorage.getItem("apexid");    
    if(apexid !== null){
      
      this.apexId = apexid;
      let driverCountry = localStorage.getItem("driverCountry");
      let driverBusinessType = localStorage.getItem("driverBusinessType");
      if(driverCountry !== null){
        if(driverCountry === 'CN'){
            this.showEconomyKpi = true;            
        }
        if(driverCountry === 'TW'){
          this.showHomeButton = false;            
        }
        this.cdr.detectChanges();
        this.teamMessageService.getTeamMessageByApexId(this.apexId).subscribe(responseTeamMessageObject => {
          // driver not exist
          if(responseTeamMessageObject.length === 0){
            this.teamMessageNotReadCunt = null;
            localStorage.setItem('dashboardTeamMessageDetails', JSON.stringify([null]));
          }          
          else{
            let driverBusinessType = responseTeamMessageObject[0].driver.businessType;
            console.log(`driverBusinessType is ${driverBusinessType}`);
            localStorage.setItem('driverBusinessType', driverBusinessType);

            let driverStartDate = responseTeamMessageObject[0].driver.startDate;
            console.log(`driverStartDate is ${driverStartDate}`);
            localStorage.setItem('driverStartDate', driverStartDate);

            let driverId = responseTeamMessageObject[0].driver.driver_Id;
            console.log(`driver_Id is ${driverStartDate}`);
            localStorage.setItem('driverId', driverId);
            
            // driver exist, but no team message
            if(responseTeamMessageObject[0].dashboardTeamMessageDetails[0] === null){              
              this.teamMessageNotReadCunt = null;                                 
            }
            // driver exist, and has team message
            else{
              let count = responseTeamMessageObject[0].dashboardTeamMessageDetails.filter((item: any) => item.readTime === null).length;                        
              this.teamMessageNotReadCunt = count === 0 ? null : count;              
            }
            localStorage.setItem('dashboardTeamMessageDetails', JSON.stringify(responseTeamMessageObject[0].dashboardTeamMessageDetails));
          }
          this.isLoading = false;  
        });
      }
      else{          
        this.teamMessageService.getTeamMessageByApexId(this.apexId).subscribe(responseTeamMessageObject => {
          if(responseTeamMessageObject.length === 0){
            this.teamMessageNotReadCunt = null;
            localStorage.setItem('dashboardTeamMessageDetails', JSON.stringify([null]));
          }
          else{
            let driverCountry = responseTeamMessageObject[0].driver.terminal.country;
            console.log(`driverCountry is ${driverCountry}`);
            localStorage.setItem('driverCountry', driverCountry);

            let driverBusinessType = responseTeamMessageObject[0].driver.businessType;
            console.log(`driverBusinessType is ${driverBusinessType}`);
            localStorage.setItem('driverBusinessType', driverBusinessType);            

            let driverStartDate = responseTeamMessageObject[0].driver.startDate;
            console.log(`driverStartDate is ${driverStartDate}`);
            localStorage.setItem('driverStartDate', driverStartDate);

            let driverId = responseTeamMessageObject[0].driver.driver_Id;
            console.log(`driver_Id is ${driverStartDate}`);
            localStorage.setItem('driverId', driverId);

            this.driverCountry = driverCountry
            
            if(this.driverCountry === 'CN'){
                this.showEconomyKpi = true;                                  
            }
            if(this.driverCountry === 'TW'){
              this.showHomeButton = false;                                  
            }
            this.cdr.detectChanges();
            if(responseTeamMessageObject[0].dashboardTeamMessageDetails[0] === null){
              this.teamMessageNotReadCunt = null;
            }
            else{
              let count = responseTeamMessageObject[0].dashboardTeamMessageDetails.filter((item: any) => item.readTime === null).length;              
              this.teamMessageNotReadCunt = count === 0 ? null : count;            
            }
            localStorage.setItem('dashboardTeamMessageDetails', JSON.stringify(responseTeamMessageObject[0].dashboardTeamMessageDetails)); 
          }
          this.isLoading = false;  
        });
      }        
    }
    this.cdr.detectChanges();
  }
  teamMessageNotReadCunt!:any;
  driverCountry = localStorage.getItem("driverCountry");
  showEconomyKpi = localStorage.getItem("driverCountry") === null ? false : localStorage.getItem("driverCountry") === 'CN' ? true : false;
  showHomeButton = localStorage.getItem("driverCountry") === null ? true : localStorage.getItem("driverCountry") === 'TW' ? false : true;

  ngOnDestroy(): void {
      this._destroying$.next(undefined);
      this._destroying$.complete();
  }

  login() {
    console.log(`login clicked`);
      if (this.msalGuardConfig.authRequest)
          this.authService.loginRedirect(
              { ...this.msalGuardConfig.authRequest } as RedirectRequest
          );
      else
          this.authService.loginRedirect();
  }

  logout() {
      this.authService.logoutRedirect();
  }

  viewProfile() {
      this.ngZone.run(() => this.router.navigate(['profile']));
  }
  onGoToMonthPerformance(){
    this.ngZone.run(() => this.router.navigate(['month-performance']));
  }
  onGoToYearPerformance(){
    this.ngZone.run(() => this.router.navigate(['year-performance']));
  }
  onGoToScore(){
    this.ngZone.run(() => this.router.navigate(['score']));
  }
  onGoToEconomy(){
    this.ngZone.run(() => this.router.navigate(['economy-kpi']));
  }
  onGoToAchievement(){
    this.ngZone.run(() => this.router.navigate(['achievement']));
  }

  onGoToCoaching(){
    this.ngZone.run(() => this.router.navigate(['coaching']));
  }

  onGoToLearnex(){
    this.ngZone.run(() => this.router.navigate(['learnex']));
  }

}
